import { I2PEnvironment } from '@price-for-profit/micro-services';
import { AppConfig } from 'shared/types';
import SplunkOtelWeb from '@splunk/otel-web';
import SplunkSessionRecorder from '@splunk/otel-web-session-recorder';

interface GetInsightEnvironmentProps {
  serviceBaseUrl: string;
}

export function getInsightEnvironment({
  serviceBaseUrl,
}: GetInsightEnvironmentProps): Exclude<I2PEnvironment, 'model'> {
  if (serviceBaseUrl.includes('modeling') || serviceBaseUrl.includes('dev')) {
    return 'dev';
  } else if (serviceBaseUrl.includes('sandbox')) {
    return 'sandbox';
  } else {
    return 'prod';
  }
}

export function initSplunk(appConfig: AppConfig, env: string) {
  console.log('Calling SplunkOtelWeb.init...');
  SplunkOtelWeb.init({
    realm: appConfig.splunkRealm,
    rumAccessToken: appConfig.splunkRumAccessToken,
    applicationName: `Demo PCQ Portal - ${env}`,
    deploymentEnvironment: env, // e.g. 'dev', 'sandbox', or 'prod'
    // debug: true,
  });
  console.log('SplunkOtelWeb.init call complete.');
  console.log('Calling SplunkSessionRecorder.init...');
  SplunkSessionRecorder.init({
    realm: appConfig.splunkRealm,
    rumAccessToken: appConfig.splunkRumAccessToken,
  });
  console.log('SplunkSessionRecorder.init call complete.');
}
